<template>
  <div class="user-change-data">
    <Form ref="form" v-slot="{ handleSubmit }" :validation-schema="schema" as="div">
      <div class="uq-stripe-form-container row text-white">
        <div class="form-group col-12 mb-16 ">
          <label class="text-xs mb-5">{{ trans.newEmail ?? 'New Email' }}</label>
          <Field
            id="email"
            v-model="subscriberInformation.email"
            aria-describedby="email"
            class="form-control"
            name="email"
            type="text"
          />

          <ErrorMessage class="invalid-feedback" name="email"/>
        </div>

        <div class="form-group col-12 mb-16 ">
          <label class="text-xs mb-5">{{ trans.newName ?? 'New name' }}</label>
          <Field
            id="name"
            v-model="subscriberInformation.name"
            aria-describedby="name"
            class="form-control"
            name="name"
            type="text"
          />

          <ErrorMessage class="invalid-feedback" name="name"/>
        </div>

        <div class="form-group col-12 mb-16 ">
          <label class="text-xs mb-5">{{ trans.newSurname ?? 'New surname' }}</label>
          <Field
            id="surname"
            v-model="subscriberInformation.surname"
            aria-describedby="surname"
            class="form-control"
            name="surname"
            type="text"
          />

          <ErrorMessage class="invalid-feedback" name="surname"/>
        </div>

        <p v-if="errorMessage?.length > 0" class="error mb-12 d-block text-md">
          {{ errorMessage }}
        </p>

        <p v-if="successMessage?.length > 0" class="mb-12 d-block text-md">
          {{ successMessage }}
        </p>

        <div class="submit-section mb-16">
          <button
            :disabled="disabledButton || loading"
            class="btn btn-primary w-100 mb-8 mt-12 py-12"
            type="button"
            @click="handleSubmit($event, saveChanges)">
            <span v-if="!loading">{{ trans.saveChanges ?? 'Save Changes' }}</span>
            <span v-else>{{ trans.loading ?? 'Loading' }}</span>
          </button>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import { ErrorMessage, Field, Form } from 'vee-validate';
import * as yup from 'yup';
import api from '@assets/js/front/checkout/api';

export default {
  name: 'VChangeUserData',
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  emits: ['saved'],
  props: {
    trans: {
      required: true,
    },
    user: {
      required: true,
    },
    locale: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      subscriberInformation: {
        email: '',
        name: '',
        surname: '',
      },

      schema: {},
      successMessage: '',
      errorMessage: '',

      loading: false,
    };
  },
  computed: {
    disabledButton() {
      return !this.subscriberInformation.email && !this.subscriberInformation.name && !this.subscriberInformation.surname;
    },
  },
  async mounted() {
    const spanish = {
      mixed: {
        required: 'El campo es obligatorio',

      },
      string: {
        email: 'Introduce un email válido',
      },
    };

    const english = {
      mixed: {
        required: 'The field is required',
      },
      string: {
        email: 'Email must be a valid email',
      },
    };

    yup.setLocale(this.locale === 'es' ? spanish : english);

    this.schema = yup.object().shape({
      email: yup.string().required().email().label('email'),
      name: yup.string().required().label('name'),
      surname: yup.string().required().label('surname'),
    });
  },
  methods: {
    async saveChanges(formData) {
      this.errorMessage = '';
      this.successMessage = '';

      try {
        this.loading = true;

        let data = {
          email: formData.email,
          name: formData.name,
          surname: formData.surname,
        };

        await api.user.update(data);
        this.successMessage = this.trans.changedDataSuccessfully ?? 'Changed successfully.';

        this.$emit('saved');
      } catch (e) {
        if (!!e.response?.data?.message) {
          this.errorMessage = e.response?.data?.message;
        }

        console.error(e);
        throw e;
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    user(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.subscriberInformation = {
          email: newVal?.email ?? '',
          name: newVal?.name ?? '',
          surname: newVal?.surname ?? '',
        };
      }
    }
  }
};
</script>

<style lang="scss" scoped>
input {
  padding-inline: 1rem !important;
}

</style>
